/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdgeo5Inputs */

const en__field_enum_sdgeo5 = /** @type {(inputs: _Field_Enum_Sdgeo5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 - Geowissenschaften / Geographie`)
};

const de__field_enum_sdgeo5 = /** @type {(inputs: _Field_Enum_Sdgeo5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 - Geowissenschaften / Geographie`)
};

/**
* | output |
* | --- |
* | "11 - Geowissenschaften / Geographie" |
*
* @param {_Field_Enum_Sdgeo5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdgeo5 = /** @type {((inputs?: _Field_Enum_Sdgeo5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdgeo5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdgeo5(inputs)
	return de__field_enum_sdgeo5(inputs)
});
export { _field_enum_sdgeo5 as "_field_enum_SDGEO" }